import { stringify } from 'query-string'
import api from 'services/api'

export function stringifyPageQuery (params) {
  let query = {
    pageNumber: JSON.stringify(params.page),
    pageSize: JSON.stringify(params.rowsPerPage),
    sort: params.sort.map(param => formatCamelToSnakeCase(param.param + ',' + param.order))
  }
  params.filters.forEach(filter => {
    query[filter.key] = filter.value
  })
  return stringify(query)
}

export function stringifyFiltersQuery (filters) {
  let query = {}
  filters.forEach(filter => {
    query[filter.key] = filter.value
  })
  return stringify(query)
}

function formatCamelToSnakeCase (string) {
  return string.replace(/[\w]([A-Z])/g, (m) => m[0] + '_' + m[1]).toUpperCase()
}

export const uploadFile = (file, url, params) => {
  let formData = new FormData()
  formData.append('file', file)
  if (params) {
    params.forEach(param => {
      formData.append(param.name, param.value)
    })
  }
  return api.post(url, formData)
}

export const downloadFile = (path, filename) =>
  api.get(path, { responseType: 'blob' })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
